import { RedDayCriteria } from "us.collection.admin/interfaces";
/**
 * @function
 * @description set all criteria value true
 * @param {Array<RedDayCriteria>} criteria
 * @returns {Array<RedDayCriteria>}
 */
export const setAllCriteriaTrue = (
  criteria: Array<RedDayCriteria>,
): Array<RedDayCriteria> => {
  try {
    return criteria.map((item: RedDayCriteria) => ({ ...item, value: true }));
  } catch (error) {
    return criteria;
  }
};
